import { render, staticRenderFns } from "./CurrentFilesV2.vue?vue&type=template&id=2b841fd6&"
import script from "./CurrentFilesV2.vue?vue&type=script&lang=js&"
export * from "./CurrentFilesV2.vue?vue&type=script&lang=js&"
import style0 from "./CurrentFilesV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports